export default __webpack_public_path__ + "static/media/588.5828d9c3.png";